import React from "react";
import { useTranslation } from "react-i18next";
import BrandNav from "../../components/BrandNav";

export default function RoboticsLanding() {
  const { t } = useTranslation();
  return (
    <>
      <BrandNav />
      <main className="ftg-page">
        <h1>{t("robotics.landing_title")}</h1>
        <p>{t("robotics.landing_subtitle")}</p>
      </main>
    </>
  );
}
